/* eslint-disable */
import Divider from "components/Divider";
import H4 from "components/H4";
import H5 from "components/H5";
import React, { useState } from "react";
import styled from "styled-components";
import Svg from "_assets/svg";
import { useDispatch } from "react-redux";
import { useHistory, Redirect } from "react-router-dom";
import { logout } from "_redux/actions/authAction";
import DropdownWrapper from "./DropdownWrapper";
import { getInitial, stringToHslColor } from "utils/helpers";
import SettingsIcon from "_assets/icons/settings.svg";
import "./menuUser.scss";

const Button = styled.button`
  // padding-left: 10px;
  // padding-right: 15.83px;
  padding: 5px 8px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 50px;
  &:focus {
    outline: 0px;
  }
`;

const Img = styled.img`
  ${(props) => `
    width: ${props.size ? `${props.size}px` : "32px"};
    height: ${props.size ? `${props.size}px` : "32px"};
    border-radius: ${props.size ? `${props.size / 2}px` : "18px"};
  `}
`;

const Arrow = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 5px;
`;

const H3 = styled.span`
  /* Project Barongsai */

  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  color: #3a3c40;
`;

const H6 = styled.span`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #838890;
  /* identical to box height, or 150% */
`;

const DropdownButton = styled.button`
  padding-block: 10px;
  padding-inline: 5px;
  background: transparent;
  border-radius: 8px;
  border: 0px;
  cursor: pointer;
  &:focus {
    outline: 0px;
  }
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

const DropdownImg = styled.img`
  width: 20px;
  height: 20px;
`;

const ButtonUserWrapper = (props) => {
  const { isLogout, title, svg, onPress } = props;
  return (
    <DropdownButton onClick={onPress} className="d-flex flex-row align-items-center w-100">
      <DropdownImg src={svg} />
      <H4 style={{ color: isLogout ? "#D63358" : "#26292D", fontWeight: "bold", marginLeft: 10 }}>
        {title}
      </H4>
    </DropdownButton>
  );
};
const ButtonUser = ({ user }) => {
  // console.log("userr", user);
  const history = useHistory();

  const dispatch = useDispatch();
  const onLogOut = () => {
    dispatch(logout());
    localStorage.removeItem("DATA_FORM");
    history.push("/auth/login");
    // window.location.reload();
  };
  const [active, setActive] = useState(false);
  const handleDropdown = () => {
    setActive(!active);
  };

  return (
    <div className="position-relative">
      {user?.avatar || user?.avatar !== "" ? (
        <Button
          className="justify-content-center align-items-center"
          onClick={() => handleDropdown()}
        >
          <Img style={{ marginRight: 0 }} src={user?.avatar} />
          {/* <H5 className="fw-bold">{user?.fullName}</H5> */}
          {/* <Arrow src={Svg.arrow_drop_down.default} /> */}
        </Button>
      ) : user?.fullName ? (
        <span
          className="initial_name flex items-center font-semibold justify-center rounded-full text-xs lg:text-xs"
          onClick={() => handleDropdown()}
          style={{
            color: stringToHslColor(
              getInitial(typeof user.fullName !== "undefined" ? user.fullName : "U"),
              38,
              50
            ),
            background: stringToHslColor(
              getInitial(typeof user.fullName !== "undefined" ? user.fullName : "U"),
              38,
              80
            ),
          }}
        >
          {getInitial(typeof user.fullName !== "undefined" ? user.fullName : "UNKNOWN")}
        </span>
      ) : (
        <span
          className="initial_name flex items-center font-semibold justify-center rounded-full text-xs lg:text-xs"
          onClick={() => handleDropdown()}
          style={{
            color: stringToHslColor(
              getInitial(typeof user.email !== "undefined" ? user.email : "U"),
              38,
              50
            ),
            background: stringToHslColor(
              getInitial(typeof user.email !== "undefined" ? user.email : "U"),
              38,
              80
            ),
          }}
        >
          {getInitial(typeof user.email !== "undefined" ? user.email : "UNKNOWN")}
        </span>
      )}
      <DropdownWrapper active={active}>
        <div
          className="justify-content-start align-items-center d-flex flex-row"
          style={{ paddingBlock: 20, paddingInline: 15, backgroundColor: "#F4F5F7" }}
        >
          {user?.avatar || user?.avatar !== "" ? (
            <Img size={70} src={user?.avatar} />
          ) : user?.fullName ? (
            <span
              className="initial_user flex items-center font-semibold justify-center rounded-full text-xs lg:text-xs"
              onClick={() => handleDropdown()}
              style={{
                color: stringToHslColor(
                  getInitial(typeof user.fullName !== "undefined" ? user.fullName : "U"),
                  38,
                  50
                ),
                background: stringToHslColor(
                  getInitial(typeof user.fullName !== "undefined" ? user.fullName : "U"),
                  38,
                  80
                ),
              }}
            >
              {getInitial(typeof user.fullName !== "undefined" ? user.fullName : "UNKNOWN")}
            </span>
          ) : (
            <span
              className="initial_user flex items-center font-semibold justify-center rounded-full text-xs lg:text-xs"
              onClick={() => handleDropdown()}
              style={{
                color: stringToHslColor(
                  getInitial(typeof user.email !== "undefined" ? user.email : "U"),
                  38,
                  50
                ),
                background: stringToHslColor(
                  getInitial(typeof user.email !== "undefined" ? user.email : "U"),
                  38,
                  80
                ),
              }}
            >
              {getInitial(typeof user.email !== "undefined" ? user.email : "UNKNOWN")}
            </span>
          )}
          <div className="ms-3">
            <h3 className="cl-neutral500 fweight-600 fsize-14 mb-2">{user?.fullName}</h3>
            <h5 className="cl-neutral300 fweight-400 fsize-14 mb-0">{user?.email}</h5>
          </div>
        </div>
        {/* <Divider style={{ marginBlock: 15, marginInline: 0 }} /> */}
        <div style={{ paddingInline: 15, paddingBottom: 15 }}>
          {/* <H6 style={{ marginBottom: 4 }}>PERSONAL</H6> */}
          <ButtonUserWrapper
            onPress={() => history.push("/profile/edit-profile")}
            svg={SettingsIcon}
            title="Settings"
          />
          {/* <ButtonUserWrapper
            onPress={() => history.push("/profile/edit-profile")}
            svg={Svg.user}
            title="Edit Profile"
          />
          <ButtonUserWrapper
            onPress={() => history.push("/profile/change-password")}
            svg={Svg.locked}
            title="Change Password"
          /> */}
          {/* <Divider style={{ marginBlock: 15, marginInline: 0 }} />
          <H6 style={{ marginBottom: 4 }}>ORGANIZATION</H6>
          <ButtonUserWrapper
            onPress={() => history.push("/profile/edit-organization")}
            svg={Svg.u_bag}
            title="Edit Organization"
          /> */}
          <Divider style={{ marginBlock: 5, marginInline: 0 }} />
          <ButtonUserWrapper svg={Svg.log_out.default} title="Logout" isLogout onPress={() => onLogOut()} />
        </div>
      </DropdownWrapper>
    </div>
  );
};

export default ButtonUser;
